import React from "react";

export interface GalleryImgSrc {
  name: string;
  imageSrc: string;
}

const isSelected = (selectedIndex: number, currentIndex: number): boolean => {
  if (selectedIndex === currentIndex) {
    return true;
  } else {
    return false;
  }
};

type GalleryItemProps = {
  onItemClick: (index: number) => void;
  currentIndex: number;
  selectedIndex: number;
  name: string;
  imageSrc: string;
};

type ImageGalleryProps = {
  title: string;
  items: GalleryImgSrc[];
  onClickItem: (index: number) => void;
  selectedIndex: number,
}

function GalleryItem({ onItemClick, currentIndex, imageSrc, name, selectedIndex }: GalleryItemProps) {
  return (
    <div
      style={{
        height: "170px",
        margin: "10px 20px 10px 20px",
        border:  "3px solid #aaa",
        display: "flex",
        flexDirection: "row",
        backgroundColor: isSelected(selectedIndex, currentIndex) ? "#F7A246" :"#FFFFFF", 
      }}
      onClick={(e) => onItemClick(currentIndex)}
    >
      <div
        style={{
          flex: "1 0 auto",
          width: "41%",
          padding: 5,
          overflow: "hidden",
        }}
      >
        <img
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
          }}
          src={imageSrc}
          alt={imageSrc}
        />
      </div>
      <div
        style={{
          flex: "1 0 auto",
          width: "59%",
        }}
      >
        <p
          style={{
            marginLeft: 9,
            marginTop: 10,
            textAlign: "left",
            whiteSpace: "pre-line",
            fontSize: "16px",
            lineHeight: "24px",
          }}
        >
          {name}
        </p>
      </div>
    </div>
  );
}

export default function ImageGallery({title, items, selectedIndex, onClickItem = () => {}}: ImageGalleryProps) {
  return (
    <>
      <div
        style={{
          height: 90,
          lineHeight: "90px",
          backgroundColor: "#414042",
          display: "block",
          color: "#FFFFFF",
          fontSize: 20,
          textAlign: "left",
          paddingLeft: 28,
        }}
      >
        {title}
      </div>
      <div
        style={{
          flex: "1 0 250px",
          overflow: "auto",
          height: "calc(100% - 90px)",
        }}
      >
        {items.map((item, i) => {
          return (
            <GalleryItem
              name={item.name}
              imageSrc={item.imageSrc}
              selectedIndex={selectedIndex}
              currentIndex={i}
              onItemClick={onClickItem}
              key={item.name}
            />
          );
        })}
      </div>
    </>
  );
}
